import React from "react";
import {Link} from "react-router-dom";
import { motion } from "framer-motion";
import "../components/LatestCollection.css";
import img1 from "../assets/6.jpg";
import img2 from "../assets/t2.jpg";
import img3 from "../assets/shirt1.jpg";
import img4 from "../assets/j1.jpg";
import img5 from "../assets/lower2.jpg";
import img6 from "../assets/jeans.jpg";

const collections = [
  {
    id: 1,
    title: "Men's Jacket",
    image:img4,
    link : "/products/garments/men/jackets"
  },
  {
    id: 2,
    title: "Men's Sweat Tops & Hoodies",
    image: img1,
    link : "/products/garments/men/hoodies"
  },
  {
    id: 5,
    title: "Men's Shorts & Lower",
    image:img5,
    link : "/products/garments/men/shorts"
  },
  {
    id: 3,
    title: "Men's T-Shirts",
    image: img2,
    link : "/products/garments/men/tshirts"
  },
  {
    id: 4,
    title: "Men's Shirts",
    image: img3,
    link : "/products/garments/men/shirts"
  },
 
  {
    id: 6,
    title: "Men's Jeans & Pant",
    image:img6,
    link : "/products/garments/men/jeans"
  },
];

export default function LatestCollection() {
  return (
    <section className="latest-collection">
      <div className="collection-header">
        <h2 id="mens-showcase">Mens Product Showcase</h2>
      </div>

      <div className="collection-grid">
  {collections.map((item, index) => (
    <Link to={item.link} key={item.id} className="collection-link">
      <motion.div
        className="collection-card"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: index * 0.2, duration: 0.6 }}
        whileHover={{ scale: 1.05 }}
      >
        <img src={item.image} alt={item.title} />
        <h4>{item.title}</h4>
      </motion.div>
    </Link>
  ))}
</div>

    </section>
  );
}
